import gql from 'graphql-tag';
import { SOCIAL_INTERACTION_TARGET_FRAGMENT } from '.';
export const SOCIAL_INTERACTION_TARGETS_QUERY = gql `
  query SocialInteractionTargets($urns: [GlobalID!]) {
    viewer {
      id
      socialInteractionTargets(urns: $urns) {
        ...SocialInteractionTarget
      }
    }
  }
  ${SOCIAL_INTERACTION_TARGET_FRAGMENT}
`;
//# sourceMappingURL=query-interaction-targets.gql.js.map